<div class="notice-board-header">
  <mat-icon class="header-icon" fontIcon="campaign"></mat-icon>
  <span class="header-title">Mural de Avisos</span>
</div>

@if (noContent()) {
  <p class="no-content-msg">Nenhum aviso disponÃ­vel no momento.</p>
} @else {
  <mat-accordion>
    @for (notice of notices(); track notice.title; let i = $index) {
      <mat-expansion-panel [expanded]="i === 0">
        <mat-expansion-panel-header class="notice-header">
          <mat-panel-title>{{ notice.title }}</mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <div class="notice-content" [innerHTML]="notice.message"></div>
      </mat-expansion-panel>
    }
  </mat-accordion>
}